<template>
  <v-container id="carriers-table" fluid>
    <v-card v-if="carriers" class="flex-column" outlined>
      <v-data-table
        :headers="headers"
        :items="carriers"
        :options.sync="options"
        :footer-props="footerProps"
        :loading="loadingData"
        :loading-text="$t('appointment.loadingServicesText')"
        :no-data-text="$t('appointment.noServices')"
        style="cursor: pointer"
        mobile-breakpoint="481"
        item-key="id"
        :header-props="headerProps"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-btn color="primary" class="mr-1" outlined :to="'/carriers/add'">
              <v-icon>mdi-plus</v-icon>
              Ajouter transporteur
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.enabled="{ item }">
          <v-simple-checkbox v-model="item.enabled" disabled></v-simple-checkbox>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn
            :class="[$vuetify.breakpoint.width >= 481 ? '' : 'pr-0']"
            text
            color="primary"
            @click="handleClick(item.id)"
          >
            Modifier
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
  export default {
    name: 'CarriersTable',
    data() {
      return {
        loadingData: false,
        options: {
          itemsPerPage: 15,
          sortDesc: [],
        },
      }
    },
    computed: {
      headers() {
        return [
          {
            text: 'Nom',
            value: 'name',
          },
          {
            text: 'Activé',
            value: 'enabled',
          },
          {
            text: '',
            value: 'action',
            sortable: false,
          },
        ]
      },
      footerProps() {
        return {
          'items-per-page-options': [15, 30, 50],
          'items-per-page-text': 'Résultats par page',
        }
      },
      headerProps() {
        return {
          sortByText: this.$t('order.sortByText'),
        }
      },
      carriers() {
        if (this.$store.state.carriersTemp) {
          return this.$store.state.carriersTemp
        }
        return []
      },
    },
    methods: {
      handleClick(carrierId) {
        this.$router.push({
          name: 'carriersDetails',
          params: {
            carrier: this.$store.state.carriersTemp.find((x) => x.id === carrierId),
          },
        })
      },
    },
  }
</script>
